<template>
  <UkiModal :modalId="modalId" title="Использовать предмет" @close="$emit('close')" @ok="$emit('ok')">
    <div class="form-group">
      <label for="item">Предмет</label>
      <span>{{itemName}}</span>
    </div>
    <div class="form-group">
      <label for="comment">Комментарий</label>
      <textarea id="comment" :value="itemComment" rows="4"
                @input="$emit('update:itemComment', $event.target.value)">
      </textarea>
    </div>
  </UkiModal>
</template>

<script>
import UkiModal from "@/components/UkiModal";

export default {
  name: "UseItemModal",
  components: {UkiModal},
  props: ["modalId", "itemName", "itemComment"],
  emits: ["ok", "cancel", "update:itemComment"]
}
</script>

<style scoped>

</style>